import { apiRequest } from '@/api/client';
import type { SeoNetworkView, SiteSeoView } from '@/types/api';

/** SEO checks (ADR-0045): one site's, and the whole network's. */
export const seoApi = {
  network: () => apiRequest<SeoNetworkView>('/seo'),
  site: (siteId: string) => apiRequest<SiteSeoView>(`/sites/${siteId}/seo`),
  requestCheck: (siteId: string) => apiRequest<{ requested: boolean }>(`/sites/${siteId}/seo/check`, { method: 'POST', body: {} }),
  addKeyPage: (siteId: string, path: string) => apiRequest<{ id: string; path: string }>(`/sites/${siteId}/seo/key-pages`, { method: 'POST', body: { path } }),
  removeKeyPage: (siteId: string, pageId: string) => apiRequest<{ removed: boolean }>(`/sites/${siteId}/seo/key-pages/${pageId}`, { method: 'DELETE' }),
};
